import { Component, inject, Input } from '@angular/core';
import { Configuration } from '../../../../../models/configurators-2d/applications/fence/configuration';
import { FenceService } from '../../../../../services/configurators-2d/applications/fence.service';

@Component({
  selector: 'ng-fence-preview-shape',
  templateUrl: './fence-preview-shape.component.html',
  styleUrl: './fence-preview-shape.component.scss',
})
export class FencePreviewShapeComponent {
  private readonly fenceService = inject(FenceService);

  protected get configuration(): Configuration {
    return this.fenceService.configuration;
  }

  /**
   * Fonction de détermination de l'arrière-plan à afficher
   * @returns objet style
   */
  protected get backgroundImageStyles(): object {
    if (this.configuration.shape != undefined) {
      return {
        'background-image': 'url("' + this.fenceService.imgPath(this.configuration.shape.picture) + '")',
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        'padding': '10px',
        'background-origin': 'content-box',
      };
    }

    return {
      'background-image': 'url("' + this.fenceService.imgPath(this.configuration.location.picture.path) + '")',
    };
  }
}
